"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const lib_1 = require("@brandfree-front/lib");
const GaButton_1 = __importDefault(require("../../util/GaButton"));
const StoresUtil_1 = require("../../util/StoresUtil");
const crm_components_1 = require("crm-components");
const ApiUtil_1 = require("../../util/ApiUtil");
let GDPRSignOnScreen = class GDPRSignOnScreen extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "dealerConsentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "consentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "partyPrivacyProfileStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onClickClear", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (signature) => {
                signature.clear();
                this.onDrawEnd();
            }
        });
        Object.defineProperty(this, "onClickClearOrChangeEmployeeSignature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (signature) => {
                this.dealerConsentStore.employeeSignatureValueFromDatabase = null;
                await this.dealerConsentStore.deleteEmployeeSignature();
                this.onClickClear(signature);
                this.dealerConsentStore.employeeSignature.on();
            }
        });
        Object.defineProperty(this, "onDrawEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.dealerConsentStore.validateSignatures();
            }
        });
        Object.defineProperty(this, "onBackButtonClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.consentStore.restoreConsentsPreviousSelections();
                (0, crm_components_1.navigate)('/gdpr');
            }
        });
        Object.defineProperty(this, "onConfirmSignaturesClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                this.setState({ isLoading: true });
                this.dealerConsentStore.selectedConsentSigners.forEach((signer) => signer.signature.off());
                this.partyPrivacyProfileStore
                    .signOnScreenProfile()
                    .then(() => {
                    this.setState({ isLoading: false });
                    (0, crm_components_1.navigate)('/success');
                })
                    .catch(() => {
                    this.setState({ isLoading: false });
                    (0, crm_components_1.navigate)('/gdpr');
                });
            }
        });
        this.state = {
            isLoading: false
        };
    }
    async componentDidMount() {
        await this.dealerConsentStore.initSignatureValue();
    }
    render() {
        var _a;
        const { translate } = this.translateStore;
        if (!((_a = this.partyPrivacyProfileStore.preparedProfiles) === null || _a === void 0 ? void 0 : _a.length)) {
            return null;
        }
        return (react_1.default.createElement(lib_1.Text, null,
            react_1.default.createElement(lib_1.Heading, { className: "h2" }, translate('gdpr.signonscreen.sign.title')),
            react_1.default.createElement(lib_1.Separator, { spacing: 'large', color: 'invisible' }),
            this.getSignableAgreementDocumentTabs(),
            this.getSignatureCanvasses(),
            react_1.default.createElement(lib_1.Signature, { key: 'gdpr-signer-employee', className: this.dealerConsentStore.employeeSignatureValueFromDatabase && !this.dealerConsentStore.wasSignatureChanged
                    ? 'text__margin-double signature--disabled'
                    : 'text__margin-double', label: translate('gdpr.signonscreen.dealer.signature'), variant: "light", employee: true, isInvalid: this.dealerConsentStore.employeeSignature && this.dealerConsentStore.employeeSignature.isEmpty(), onClear: () => this.onClickClearOrChangeEmployeeSignature(this.dealerConsentStore.employeeSignature), onBegin: () => {
                    this.dealerConsentStore.wasSignatureChanged = true;
                }, onEnd: this.onDrawEnd, clearButton: this.clearOrChangeButtonProps, elementRef: (ref) => {
                    if (ref && this.dealerConsentStore.employeeSignatureValueFromDatabase) {
                        ref.fromDataURL(this.dealerConsentStore.employeeSignatureValueFromDatabase, {});
                    }
                    this.dealerConsentStore.employeeSignature = ref;
                } }),
            react_1.default.createElement(lib_1.Grid, { align: ['center-xs', 'middle-xs'] },
                react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] },
                    react_1.default.createElement(GaButton_1.default, { id: "gdpr-sign-on-screen-back", text: translate('gdpr.sign.back'), iconLeft: "#arrow-left", link: true, type: "employee", onClick: this.onBackButtonClick })),
                react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] }, this.consentStore.confirmLoading || this.state.isLoading ? (react_1.default.createElement(lib_1.Spinner, null)) : (react_1.default.createElement(GaButton_1.default, { id: "gdpr-sign-on-screen-confirm", text: translate('gdpr.sign.confirm'), type: "employee", isLoading: this.dealerConsentStore.confirmLoading || this.state.isLoading, disabled: !this.dealerConsentStore.allSignaturesValid, onClick: this.onConfirmSignaturesClick }))))));
    }
    getSignatureCanvasses() {
        const { translate } = this.translateStore;
        return this.dealerConsentStore.selectedConsentSigners.map((signer, index) => (react_1.default.createElement(lib_1.Signature, { key: `gdpr-signer-customer-${index}`, className: this.state.isLoading ? 'text__margin-double signature--disabled' : 'text__margin-double', label: signer.firstName.concat(' ').concat(signer.lastName).concat(' ').concat(translate('gdpr.signonscreen.signature')), employee: false, variant: "light", onEnd: this.onDrawEnd, onClear: () => this.onClickClear(signer.signature), clearButton: this.clearButtonProps, elementRef: (ref) => (signer.signature = ref) })));
    }
    getSignableAgreementDocumentTabs() {
        const preparedAgreements = this.partyPrivacyProfileStore.preparedProfiles[0].partyPrivacyAgreements;
        return (react_1.default.createElement(lib_1.Tabs, { "aria-labelledby": "gdpr-documents", size: "huge", defaultCurrentTab: `gdpr-document-${preparedAgreements[0].agreementType}`, border: "top" }, preparedAgreements.map((preparedAgreement, index) => (react_1.default.createElement(lib_1.TabsItem, { id: `gdpr-document-${preparedAgreement.agreementType}`, label: this.translateStore.translate(`gdpr.consent.type.${preparedAgreement.agreementType}`), key: `gdpr-document-${index}` },
            react_1.default.createElement("embed", { src: this.getAgreementDocumentLink(preparedAgreement), width: "100%", height: "1000", type: "application/pdf" }))))));
    }
    getAgreementDocumentLink(agreement) {
        return `${ApiUtil_1.apiBaseUrl}/privacy-agreement/${agreement.id}/document-inline`;
    }
    get clearOrChangeButtonProps() {
        const { translate } = this.translateStore;
        return {
            text: translate('gdpr.signonscreen.clearorchange.signature'),
            iconLeft: '#close',
            variant: 'secondary'
        };
    }
    get clearButtonProps() {
        const { translate } = this.translateStore;
        return {
            text: translate('gdpr.signonscreen.clear.signature'),
            iconLeft: '#close',
            variant: 'secondary'
        };
    }
};
GDPRSignOnScreen = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], GDPRSignOnScreen);
exports.default = GDPRSignOnScreen;
